<div class="centered-popover" mdl-shadow="8" *ngIf="message">
  <img class="centered-popover-close" src="assets/img/close.svg" (click)="close()" />
  <div class="centered-popover-body">{{ message | translate:lang }}</div>
</div>
<div class="section-shadow" *ngIf="message"></div>
